import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  'receipt-payment-instrument-card:paid-with': {
    id: 'receipt-payment-instrument-card:paid-with',
    defaultMessage: 'Paid with {paymentType}',
    description: 'Receipt Payment Instrument Card: Title for payment instrument in receipts',
  },
});
